// Module
var code = "<explore-container></explore-container> ";
// Exports
module.exports = code;